/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
// import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Stack,
  Typography,
  Autocomplete,
  TextField,
  InputAdornment,
  IconButton,
  Snackbar,
  Alert,
  Tooltip
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SearchIcon from '@mui/icons-material/Search';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TablePagination from '@mui/material/TablePagination';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DatePicker from 'react-datepicker';
import dateFormat from 'dateformat';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../../utils/errorPages/Loader';
import AuditAction from '../../store/actions/AuditAction';
import AuditTrialDetail from './details';

export default function AuditTrail() {
  const [paginationData, setPaginationData] = React.useState({
    page: 0,
    pageSize: 10
  });
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [specificDate, setSpecificDate] = useState(null);
  const [dateValue, setDateValue] = React.useState('specific-date');
  const [rowCountState, setRowCountState] = React.useState(0);
  const [data, setData] = React.useState({});
  const [moduleData, setModuleData] = React.useState([]);
  const [userData, setUserData] = React.useState([]);
  const [itemID, setItemID] = React.useState('');
  const [userId, setUserId] = React.useState('');
  const [moduleValue, setModuleValue] = React.useState('');
  const [recordId, setRecordId] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [viewOpen, setViewOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { auditData, auditModuleData, auditUserData, isLoading } = useSelector(
    (state) => state.audit
  ); // Replace 'data' with your reducer name
  const [checkedAction, setCheckedAction] = useState('');

  const handleActionChange = (event) => {
    const { name, checked } = event.target;
    setCheckedAction((prevChecked) => {
      // Toggle the value in the comma-separated string based on checkbox change
      if (checked) {
        return prevChecked ? `${prevChecked},${name}` : name;
      }
      return prevChecked
        .split(',')
        .filter((value) => value !== name)
        .join(',');
    });
    setPaginationData({ page: 0, pageSize: 10 });
  };

  useEffect(() => {
    dispatch(AuditAction.getFilterModule());
    dispatch(AuditAction.getFilterUser());
  }, [dispatch]);

  useEffect(() => {
    const rangeDate = {
      dateStart: startDate,
      dateEnd: endDate
    };
    dispatch(
      AuditAction.getAll(
        paginationData,
        checkedAction,
        specificDate,
        rangeDate,
        userId,
        moduleValue,
        recordId
      )
    );
  }, [
    dispatch,
    paginationData,
    checkedAction,
    specificDate,
    startDate,
    endDate,
    auditModuleData,
    userId,
    moduleValue,
    recordId
  ]);

  useEffect(() => {
    if (auditData) {
      if (auditData?.data || auditData?.data?.length > 0) {
        setData(auditData.data);
      } else {
        setData({});
      }
      setRowCountState(auditData?.pagination?.total || 0);
    }
    if (auditModuleData) {
      setModuleData(auditModuleData);
    }
    if (auditUserData) {
      setUserData(auditUserData);
    }
  }, [auditData, auditModuleData, auditUserData]);

  // const navigate = useNavigate();
  const handleRangePicker = (date) => {
    if (!date || date.length !== 2 || date[1] === null) {
      return;
    }
    const formatDate = (newdate) => {
      return dateFormat(newdate, 'yyyy-mm-dd');
    };
    setDateRange(date.map(formatDate));
  };
  const handleDatePicker = (date) => {
    if (date) {
      const newDate = new Date(date); // Parse the date string into a Date object
      const newDateFormat = dateFormat(newDate, 'yyyy-mm-dd');
      setSpecificDate(newDateFormat); // Set the specific date state
    }
  };

  const handleDateChange = (event) => {
    if (dateValue === 'specific-date') {
      setDateRange([]);
      setSpecificDate(null);
    } else {
      setSpecificDate(null);
    }
    if (event.target.value === 'specific-date') {
      setDateRange([]);
      setSpecificDate(null);
    } else {
      setSpecificDate(null);
    }
    setDateValue(event.target.value);
  };

  const handlePageChange = (event, value) => {
    setPaginationData({
      ...paginationData,
      page: value
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setPaginationData({
      page: 0,
      pageSize: parseInt(event.target.value, 10)
    });
  };

  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Typography className="" component="h2" variant="h2">
          Audit Trail
        </Typography>
      </div>
      <Card sx={{ width: '100%' }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={8} xl={8} className="auditTrailWrap">
              <Box>
                {data && Object.keys(data).length > 0 ? (
                  Object.keys(data).map((date, index) => (
                    <Grid container key={index}>
                      <Grid item xs={2} xl={4}>
                        <Typography
                          sx={{
                            m: '20px 0 !important'
                          }}
                          variant="h3"
                          component="h3"
                          dangerouslySetInnerHTML={{ __html: date }}
                        />
                      </Grid>
                      <Grid item xs={10} xl={8}>
                        {data[date].map((audit, idx) => (
                          <Stack
                            direction="row"
                            key={idx}
                            sx={{ my: 2, alignItems: 'flex-start' }}
                            spacing={2}
                          >
                            <Button
                              sx={{
                                p: '15px !important',
                                minWidth: '80px !important'
                              }}
                              variant="text"
                            >
                              {audit.time}
                            </Button>
                            <Card
                              sx={{
                                m: 2,
                                width: '100%',
                                borderLeft: `5px solid ${audit.color}`,
                                position: 'relative'
                              }}
                            >
                              {audit.record_id ? (
                                <CardHeader
                                  subheader={`#${audit.record_id}`}
                                  action={
                                    <Stack direction="row" spacing={2}>
                                      <Tooltip title="View" arrow>
                                        <IconButton
                                          aria-label="settings"
                                          size="small"
                                          onClick={() => {
                                            setItemID(audit._id);
                                            setViewOpen(true);
                                            // navigate(`/audit-trial/view/${audit._id}`);
                                          }}
                                        >
                                          <RemoveRedEyeOutlinedIcon fontSize="inherit" />
                                        </IconButton>
                                      </Tooltip>
                                      <CopyToClipboard
                                        text={audit.record_id}
                                        onCopy={() => handleClick()}
                                      >
                                        <Tooltip title="Copy Record ID" arrow>
                                          <IconButton aria-label="settings" size="small">
                                            <ContentCopyIcon fontSize="inherit" />
                                          </IconButton>
                                        </Tooltip>
                                      </CopyToClipboard>
                                    </Stack>
                                  }
                                />
                              ) : (
                                <CardHeader
                                  sx={{ background: 'none!important', p: '0px !important' }}
                                  action={
                                    <Tooltip title="View" arrow>
                                      <IconButton
                                        aria-label="settings"
                                        size="small"
                                        onClick={() => {
                                          setItemID(audit._id);
                                          setViewOpen(true);
                                          // navigate(`/audit-trial/view/${audit._id}`);
                                        }}
                                        sx={{ position: 'absolute', right: '20px' }}
                                      >
                                        <RemoveRedEyeOutlinedIcon fontSize="inherit" />
                                      </IconButton>
                                    </Tooltip>
                                  }
                                />
                              )}
                              <CardContent>
                                <Typography
                                  variant="body1"
                                  component="p"
                                  dangerouslySetInnerHTML={{ __html: audit.event }}
                                />
                              </CardContent>
                            </Card>
                          </Stack>
                        ))}
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <Typography
                    component="h2"
                    variant="h2"
                    sx={{
                      p: 8,
                      textAlign: 'center',
                      opacity: 0.5,
                      fontSize: '26px !important',
                      fontStyle: 'italic',
                      fontWeight: '700'
                    }}
                  >
                    No Result Found
                  </Typography>
                )}
              </Box>
              <Box className="pagination">
                <TablePagination
                  component="div"
                  count={rowCountState}
                  page={paginationData?.page}
                  onPageChange={handlePageChange}
                  rowsPerPage={paginationData?.pageSize}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            </Grid>
            <Grid item xs={4} xl={4} className="filterWrap">
              <Card sx={{ mt: 2, width: '100%' }}>
                <CardHeader title="Filters" />
                <CardContent sx={{ p: 4 }}>
                  <TextField
                    id="name"
                    fullWidth
                    label="Record ID"
                    margin="normal"
                    placeholder="Enter Record ID"
                    onBlur={(e) => {
                      if (e.target.value) {
                        setRecordId(e.target.value);
                      } else {
                        setRecordId('');
                      }
                      setPaginationData({ page: 0, pageSize: 10 });
                    }}
                    onChange={() => {
                      // if (e.target.value) {
                      //   setRecordId(e.target.value);
                      // } else {
                      //   setRecordId('');
                      // }
                      // setPaginationData({ page: 0, pageSize: 10 });
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            edge="end"
                            disabled
                            // color="secondary"
                          >
                            <SearchIcon sx={{ color: '#fff' }} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <Autocomplete
                    disablePortal
                    id="Module"
                    options={moduleData}
                    sx={{ mt: 2 }}
                    onChange={(e, newvalue) => {
                      if (newvalue) {
                        setModuleValue(newvalue);
                      } else {
                        setModuleValue('');
                      }
                      setPaginationData({ page: 0, pageSize: 10 });
                    }}
                    renderInput={(params) => <TextField {...params} label="Modules" />}
                  />
                  <FormControl sx={{ mt: 3, mb: 1 }} component="fieldset" variant="standard">
                    <FormLabel sx={{ mb: 1 }} component="legend">
                      Actions
                    </FormLabel>
                    <FormGroup>
                      <Grid container>
                        <Grid item md={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedAction.includes('created')}
                                onChange={handleActionChange}
                                name="created"
                              />
                            }
                            label="Created"
                          />
                        </Grid>
                        <Grid item md={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedAction.includes('updated')}
                                onChange={handleActionChange}
                                name="updated"
                              />
                            }
                            label="Updated"
                          />
                        </Grid>
                        <Grid item md={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedAction.includes('deleted')}
                                onChange={handleActionChange}
                                name="deleted"
                              />
                            }
                            label="Deleted"
                          />
                        </Grid>
                        <Grid item md={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedAction.includes('login')}
                                onChange={handleActionChange}
                                name="login"
                              />
                            }
                            label="Login"
                          />
                        </Grid>
                      </Grid>
                    </FormGroup>
                  </FormControl>
                  <Box sx={{ mb: 3 }}>
                    <Autocomplete
                      disablePortal
                      id="user"
                      options={userData}
                      sx={{ mt: 2 }}
                      getOptionLabel={(option) => option.name}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option._id}>
                            {option.name}
                          </li>
                        );
                      }}
                      onChange={(e, newvalue) => {
                        if (newvalue && newvalue._id) {
                          setUserId(newvalue._id);
                        } else {
                          setUserId('');
                        }
                        setPaginationData({ page: 0, pageSize: 10 });
                      }}
                      renderInput={(params) => <TextField {...params} label="User" />}
                    />
                  </Box>
                  <Box>
                    <FormControl>
                      <FormLabel sx={{ mb: 1 }} id="demo-controlled-radio-buttons-group">
                        Date
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={dateValue}
                        onChange={handleDateChange}
                      >
                        <FormControlLabel
                          value="specific-date"
                          control={<Radio />}
                          label="Specific Date"
                        />
                        <FormControlLabel
                          value="specific-range"
                          control={<Radio />}
                          label="Specific Range"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                  <Box className="datepicker" sx={{ mt: 3 }}>
                    {dateValue === 'specific-date' ? (
                      <DatePicker
                        selected={specificDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                          setSpecificDate(date);
                          handleDatePicker(date);
                          setPaginationData({ page: 0, pageSize: 10 });
                        }}
                        isClearable
                        customInput={
                          <TextField
                            label="Date"
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    edge="end"
                                    disabled
                                    // color="secondary"
                                  >
                                    <CalendarMonthIcon sx={{ color: '#fff' }} />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        }
                      />
                    ) : (
                      <DatePicker
                        selectsRange
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={new Date()}
                        onChange={(update) => {
                          setDateRange(update);
                          handleRangePicker(update);
                          setPaginationData({ page: 0, pageSize: 10 });
                        }}
                        monthsShown={2}
                        isClearable
                        customInput={
                          <TextField
                            label="Date"
                            fullWidth
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    edge="end"
                                    disabled
                                    // color="secondary"
                                  >
                                    <CalendarMonthIcon sx={{ color: '#fff' }} />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                        }
                      />
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Snackbar
        onClose={handleClose}
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={1000}
      >
        <Alert onClose={handleClose} severity="success" variant="filled" sx={{ width: '100%' }}>
          Record ID copied!
        </Alert>
      </Snackbar>
      {viewOpen === true ? (
        <AuditTrialDetail
          openmodal={viewOpen}
          code={itemID}
          onCloseModal={() => setViewOpen(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
